import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  select: {
    paddingTop: '7px !important',
    paddingBottom: '7px !important',
    height: '42px !important',
    display: 'flex',
    alignItems: 'center',
  },
  autocompleteInputRoot: {
    '&.MuiInputBase-root': {
      height: '56px !important',
    },
    height: '56px !important',
  },
});
